var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Environnement")]),_c('b-input',{model:{value:(_vm.env.name),callback:function ($$v) {_vm.$set(_vm.env, "name", $$v)},expression:"env.name"}}),_c('br'),_c('b-button',{on:{"click":_vm.update}},[_vm._v("Mettre à jour")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }